import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=5d8e3d55&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=5d8e3d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e3d55",
  null
  
)

export default component.exports